import {CardText, CardActions} from "material-ui/Card"
import _ from "lodash"
import {Link} from "react-router-dom"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {containers} from "@swarm2/core"
import Button from "material-ui/RaisedButton"
import ForgotIcon from "material-ui/svg-icons/action/help-outline"
import React from "react"
import SubmitIcon from "material-ui/svg-icons/action/account-circle"
import TextField from "material-ui/TextField"
import {withRouter} from "react-router-dom"
import * as Util from "../common"
import _Error from "./Error"

const M = Util.intlMessages("view.LoginView")
const EM = Util.intlMessages("view.LoginView.error")
const Error = _Error(EM)

function LoginRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {input, formErrors} = props
  return (
    <div>
      <form
        onSubmit={
          props.isSubmitAllowed ? props.submit : e => e.preventDefault()
        }
      >
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={<M id="title" />} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <p>
            <M id="description" />
          </p>
          <div>
            <TextField
              name="email"
              floatingLabelText={<M id="field.email" />}
              value={props.email}
              onChange={input.setEmail}
            />
          </div>
          <div>
            <TextField
              name="password"
              floatingLabelText={<M id="field.password" />}
              type="password"
              value={props.password}
              onChange={input.setPassword}
            />
          </div>
          <div>
            <TextField
              name="errors"
              underlineShow={false}
              disabled={true}
              errorText={formErrors.map((error, i) => (
                <Error key={i} error={error} />
              ))}
            />
          </div>
          <div />
        </CardText>
        <CardActions>
          <Button
            primary
            label={<M id="submit" />}
            type="submit"
            icon={<SubmitIcon />}
            disabled={!props.isSubmitAllowed}
            onClick={props.submit}
          />
          <Link to="/auth/forgot">
            <Button secondary label={<M id="forgot" />} icon={<ForgotIcon />} />
          </Link>
        </CardActions>
        <CardText>
          <small>
            <Link style={{color: "inherit"}} to="/privacy">
              <M id="privacy" />
            </Link>
          </small>{" "}
        </CardText>
        <CardText>
          {props.request.state === "SUCCESS" ? <M id="success" /> : null}
        </CardText>
      </form>
    </div>
  )
}
export default _.flowRight(
  containers.authSignin.Login(),
  withRouter,
  containers.willReceiveProps(props => {
    if (props.request.state === "SUCCESS") {
      props.history.push("/")
    }
    if (props.auth && props.isAllowed) {
      props.history.replace("/")
    }
  }),
  Util.DumpProps,
)(LoginRender)



// WEBPACK FOOTER //
// ./src/auth-signin/LoginView.js